var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.6464 5.64645L5.64645 17.6464L6.35355 18.3536L18.3536 6.35355L17.6464 5.64645ZM5.64645 6.35355L17.6464 18.3536L18.3536 17.6464L6.35355 5.64645L5.64645 6.35355Z","fill":"#121212"}));
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = X;

X.default = X;
